import { createSelector } from 'reselect'

import { StatisticsRootState } from '../statisticsRoot.reducer'

export const getFacebookPageStatistics = createSelector(
  (state: StatisticsRootState) => state.statisticsEditorStore.facebookPageStatistics,
  (state) => state,
)
export const getInstagramPageStatistics = createSelector(
  (state: StatisticsRootState) => state.statisticsEditorStore.instagramPageStatistics,
  (state) => state,
)

export const getFBExportedStatistics = createSelector(
  (state: StatisticsRootState) => state.statisticsEditorStore.facebookExportedStatistics,
  (state) => state,
)

export const getIGExportedStatistics = createSelector(
  (state: StatisticsRootState) => state.statisticsEditorStore.instagramExportedStatistics,
  (state) => state,
)

export const getPostTemplatesByMetric = createSelector(
  (state: StatisticsRootState) => state.statisticsEditorStore.postTemplatesByMetric,
  (state) => state,
)

export const getAggregatedPublishedPostsByTemplateCounts = createSelector(
  (state: StatisticsRootState) => state.statisticsEditorStore.aggregatedPublishedPostsByTemplateCounts,
  (state) => state,
)

export const getAggregatedPublishedPostsInsights = createSelector(
  (state: StatisticsRootState) => state.statisticsEditorStore.aggregatedPublishedPostsInsights,
  (state) => state,
)

export const getAggregatedPublishedPostsInsightsBefore = createSelector(
  (state: StatisticsRootState) => state.statisticsEditorStore.aggregatedPublishedPostsInsightsBefore,
  (state) => state,
)

export const getAggregatedPublishedTemplateCounts = createSelector(
  (state: StatisticsRootState) => state.statisticsEditorStore.aggregatedPublishedTemplateCounts,
  (state) => state,
)

export const getPublishedTemplatesExportedStatistics = createSelector(
  (state: StatisticsRootState) => state.statisticsEditorStore.aggregatedPublishedTemplateExportedStatistics,
  (state) => state,
)

export const getPublishedPostsExportedStatistics = createSelector(
  (state: StatisticsRootState) => state.statisticsEditorStore.aggregatedPublishedPostsExportedStatistics,
  (state) => state,
)

export const getPublishedTemplatesStatistics = createSelector(
  (state: StatisticsRootState) => state.statisticsEditorStore.publishedTemplatesStatistics,
  (state) => state,
)

